<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('assitive_device_management.donation_receive') }} {{ $t('globalTrans.search')}}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('globalTrans.fiscal_year')"
                    label-for="fiscal_year_id"
                    >
                    <b-form-select
                    plain
                    v-model="search.fiscal_year_id"
                    :options="fiscalYearList"
                    id="fiscal_year_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('assitive_device_management.donation_type')"
                    label-for="donation_type_id"
                    >
                    <b-form-select
                    plain
                    v-model="search.donation_type_id"
                    :options="donationTypeList"
                    id="donation_type_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
             <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                    <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
             </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('assitive_device_management.donation_receive_list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              {{  $t('globalTrans.add_new') }}
            </b-button>
            <!-- <router-link to="budget-prepare-form" :class="'btn btn-success text-light'">{{  $t('globalTrans.add_new') }}</router-link> -->
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(fiscal_year_id)="data">
                        <slot v-if="$i18n.locale=='en'">{{ $store.state.commonObj.fiscalYearList.find(doc => doc.value === parseInt(data.item.fiscal_year_id)).text_en  }}</slot>
                        <slot v-if="$i18n.locale=='bn'">{{ $store.state.commonObj.fiscalYearList.find(doc => doc.value === parseInt(data.item.fiscal_year_id)).text_bn  }}</slot>
                    </template>
                    <template v-slot:cell(action)="data">
<!--                      <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" title="Edit" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></b-button>-->
                      <b-button class="mr-2" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="view(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="xl" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <p>
        <FormV :id="editItemId" :key="editItemId" :item="item"/>
      </p>
    </b-modal>
    <b-modal id="modal-detail" size="lg" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <b-button btn btn-primary @click="pdfExport"  class="ml-4 mt-1 btn-success water-test-pdf-button">
        {{  $t('globalTrans.export_pdf') }}
      </b-button>
      <DetailModal :id="viewitemId" :key="viewitemId" :item="viewitemId" ref="details"/>
    </b-modal>

  </b-container>
</template>
<script>
import FormV from './Form'
import DetailModal from './Details'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { donationReceiveList, eligibilityCatToggleStatusApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
    mixins: [ModalBaseMasterList],
    components: {
        FormV, DetailModal
    },
    data () {
        return {
            search: {
                fiscal_year_id: '0',
                donation_type_id: '0'
            },
            editItemId: '',
            item: '',
            viewitemId: 0,
            items: [],
            rows: []
        }
    },
    computed: {
      fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      },
      donationTypeList: function () {
        return this.$store.state.AwarenessEventService.commonObj.donationTypeList
      },
      detailTitle () {
        return this.$t('assitive_device_management.donation_receive_details')
      },
      formTitle () {
            return (this.editItemId === 0) ? this.$t('assitive_device_management.donation_receive') + ' ' + this.$t('globalTrans.entry') : this.$t('assitive_device_management.donation_receive') + ' ' + this.$t('globalTrans.modify')
        },
      columns () {
          const labels = [
              { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('globalTrans.fiscal_year'), class: 'text-left' },
                { label: this.$t('assitive_device_management.month'), class: 'text-left' },
                { label: this.$t('assitive_device_management.donation_form'), class: 'text-left' },
                { label: this.$t('assitive_device_management.donation_type'), class: 'text-left' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
          ]

          let keys = []

          if (this.$i18n.locale === 'bn') {
              keys = [
                   { key: 'index' },
                    { key: 'year_name_bn' },
                    { key: 'month_name_bn' },
                    { key: 'donation_form_bn' },
                    { key: 'donation_type_name_bn' },
                    { key: 'action' }
              ]
          } else {
              keys = [
                   { key: 'index' },
                    { key: 'year_name' },
                    { key: 'month_name' },
                    { key: 'donation_form' },
                    { key: 'donation_type_name' },
                    { key: 'action' }
              ]
          }

          return labels.map((item, index) => {
              return Object.assign(item, keys[index])
          })
      }
    },
    watch: {
    },
    created () {
        this.loadData()
    },
    mounted () {
        this.search = Object.assign({}, this.search, { fiscal_year_id: this.$store.state.currentFiscalYearId })
    },
    methods: {
        searchData () {
            this.loadData()
        },
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
         view (viewitem) {
          this.viewitemId = viewitem
        },
        remove (item) {
            this.changeStatus(awarenessEventServiceBaseUrl, eligibilityCatToggleStatusApi, item)
        },
        loadData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(awarenessEventServiceBaseUrl, donationReceiveList, params).then(response => {
                if (response.success) {
                    this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                    this.paginationData(response.data)
                    // this.$store.dispatch('setList', response.data.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        },
        getRelationalData (data) {
            let fiscalYearList = {}
            let monthList = {}
            let donationTypeList = {}
            let assistiveDeviceList = {}
            const listData = data.map(item => {
                fiscalYearList = this.$store.state.commonObj.fiscalYearList.find(data => data.value === item.fiscal_year_id)
                monthList = this.$store.state.commonObj.monthList.find(data => data.value === item.month)
                donationTypeList = this.$store.state.AwarenessEventService.commonObj.donationTypeList.find(data => data.value === item.donation_type_id)
                assistiveDeviceList = this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(data => data.value === item.assistive_device_id)
                const idscCenter = this.$store.state.AwarenessEventService.commonObj.idscCenterList.find(data => data.value === item.idsc_center_id)
                const list = {
                    year_name: fiscalYearList !== undefined ? fiscalYearList.text_en : '',
                    year_name_bn: fiscalYearList !== undefined ? fiscalYearList.text_bn : '',
                    month_name: monthList !== undefined ? monthList.text_en : '',
                    month_name_bn: monthList !== undefined ? monthList.text_bn : '',
                    donation_type_name: donationTypeList !== undefined ? donationTypeList.text_en : '',
                    donation_type_name_bn: donationTypeList !== undefined ? donationTypeList.text_bn : '',
                    device_name: assistiveDeviceList !== undefined ? assistiveDeviceList.text_en : '',
                    device_name_bn: assistiveDeviceList !== undefined ? assistiveDeviceList.text_bn : '',
                  center_name: idscCenter?.text_en,
                  center_name_bn: idscCenter?.text_bn
                }
                return Object.assign({}, item, list)
            })
            return listData
          },
        pdfExport () {
          this.$refs.details.pdfExport()
        }
    }
}
</script>
